// This component handles both internal and external navigation through our site. Using GatsbyLink component, with added support for intls
// This is our CTA component
import { JSX, PropsWithChildren } from 'react';

import { InternalLink, ExternalLink } from './styles';

interface CtaProps extends JSX.IntrinsicAttributes {
  href: string,
  primary?: number,
  secondary?: number,
  m?: string[],
  minwidth?: string[],
  buttonStyle?: string
}

const Cta = ({ children, href, ...other }: PropsWithChildren<CtaProps>) => {
  const isInternal = /^\/(?!\/)|\btel:\b/.test(href);
  if (isInternal) {
    return (
      <InternalLink to={href} {...other}>
        {children}
      </InternalLink>
    );
  }
  return (
    <ExternalLink href={href} {...other}>
      {children}
    </ExternalLink>
  );
};

export const Primary = (props: PropsWithChildren<CtaProps>) => <Cta primary={1} {...props} />;

export const Secondary = (props: PropsWithChildren<CtaProps>) => <Cta secondary={1} {...props} />;

// Dynamic Takes a buttonStyle prop and styles as either a primary or secondary button
export const Dynamic = ({ buttonStyle, href, ...other }: CtaProps) => (
  <Cta
    href={href}
    primary={buttonStyle === 'red' ? 1 : 0}
    secondary={buttonStyle === 'red' ? 0 : 1}
    {...other}
  />
);
